import { useAppState } from '../../client/providers/AppProvider';
import React from 'react';
import { NeedsOnboardingInformation, usePageRequireAuth } from '../../client/hooks';
import { DashboardLayout } from '../../components/common/layout/DashboardLayout';
import { PlayerMyGames } from '../../components/dashboard/my-games/PlayerMyGames';

import Skeleton from 'react-loading-skeleton';
import { Espin_Role_Enum } from '../../generated/spin-graphql';
import { FullPageComingSoon } from '../../components/sections/FullPageComingSoon';
import { ParentMyGames } from '../../components/dashboard/my-games/ParentMyGames';

export default function DashboardMyGames() {
    const { user } = useAppState();
    usePageRequireAuth({});

    if (!!!user) {
        return (
            <DashboardLayout pageTitle="My Games">
                <div className="my-games">
                    <Skeleton height={228} borderRadius={15} />
                </div>
            </DashboardLayout>
        );
    }
    // TODO probably need to remove this page from parent access?
    return (
        <DashboardLayout pageTitle="My Games">
            <NeedsOnboardingInformation>
                {user.role === Espin_Role_Enum.EspinCollegeUser && <FullPageComingSoon />}
                {user.role === Espin_Role_Enum.EspinHighschoolUser && <FullPageComingSoon />}
                {user.role === Espin_Role_Enum.EspinPlayerUser && <PlayerMyGames user={user} />}
                {user.role === Espin_Role_Enum.EspinParentUser && <ParentMyGames user={user} />}
            </NeedsOnboardingInformation>
        </DashboardLayout>
    );
}
